export class ProjectSearch {

    companyId: string;
    hashTrackId: string;
    totalItems: number;
    skip: number;
    limit: number = 10;
}


// WEBPACK FOOTER //
// ./src/app/models/ProjectSearch.model.ts